import { Component, inject, OnInit, signal } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Api } from '../../../../../../services/api.service';
import { debugLogger } from '@common-helpers/debug-logger';
interface IGlobalBeeFreeTemplateModel {
    id: string;
    name: string;
    thumbnailUrl?: string;
    comment?: string;
    data: unknown;
}
@Component({
    selector: 'template-selector',
    templateUrl: './template-selector.html',
    imports: [TranslatePipe]
})
export class TemplatePickerComponent implements OnInit {
    api = inject(Api);
    translate = inject(TranslateService);
    dialogConfig = inject(DynamicDialogConfig);
    dialog = inject(DynamicDialogRef);
    availableTemplates = signal<IGlobalBeeFreeTemplateModel[]>([]);
    async ngOnInit(): Promise<void> {
        let templates = await this.api.currentorganization().get<IGlobalBeeFreeTemplateModel[]>('/crm/third-party/beefree/templates');
        debugLogger.info('templates', templates);
        if (templates.success && templates.data) {
            this.availableTemplates.set(templates.data);
        }
    }

    selectedTemplate(template: any): void {
        this.dialogConfig.data.templateSelected(template);
        this.dialog.close();

        debugLogger.info('Template selected');
    }
}
